<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <a @click="gotoUserJourneyDetails(params.data.UID, params.data.Uname)">
      <!--<feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />-->
      <!--{{ params.value }} {{ params.colName }}-->

      <svg
        v-show="params.value>0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 30 12"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class
      >
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    </a>
    <!--<feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(params.id)" />-->
    <!--<router-link
      :to="url"
      class="text-inherit hover:text-primary"
      @click="pageViewAction(params.page)"
    >{{ params.value }}</router-link>-->
  </div>
</template>

      //@click.stop.prevent
<script>
export default {
  name: "CellRendererActions",
  methods: {
    gotoPageViewUser(id) {
      //console.log(id);
      //id = window.btoa(id);
      //debugger;
      this.$router
        .push({
          name: "analytics-page-view-user",
          params: {
            page: id,
            type: "view"
          }
        })
        .catch(() => {});

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    gotoPageViewAction(id) {
      //console.log(id);
      //id = window.btoa(id);
      //debugger;
      this.$router
        .push({
          name: "analytics-page-view-user",
          params: {
            page: id,
            type: "action"
          }
        })
        .catch(() => {});

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    gotoPageViewDetails(id, type, uid, userName) {
      //console.log(id);
      //id = window.btoa(id);
      //debugger;
      this.$router
        .push({
          name: "analytics-page-view-user-details",
          params: {
            page: id,
            type: type,
            uid: uid,
            userName: userName
          }
        })
        .catch(() => {});

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    gotoUserJourneyDetails(uid, userName) {
      //console.log(id);
      //id = window.btoa(id);
      //debugger;
      this.$router
        .push({
          name: "analytics-user-journey-details",
          params: {
            uid: uid,
            userName: userName
          }
        })
        .catch(() => {});
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      //this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store
        .dispatch("attendeeManagement/removeRecord", this.params.id)
        .then(res => {
          if (res.status == 200) {
            this.$store.dispatch("attendeeManagement/fetchAttendees");
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Record Deleted",
        text: "The selected record was successfully deleted"
      });
    }
  }
};
</script>
